export default (set, get, violatingSegments) => set(
  () => ({
    violatingSegments: { ...violatingSegments }
  }),
  false,
  { type: 'updateViolatingSegments', payload: Object.keys(violatingSegments) }
);
